module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The Theater of God’s Glory: Calvin, Creation, and the Liturgical Arts")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "OT",
    attrs: {
      "id": "abb001"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#abbreviations"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('table', {
    staticClass: "abbre",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("AB")]), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Anchor Bible")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("AGJU")]), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Arbeiten zur Geschichte des antiken Judentums und des Urchristentums")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("BECNT")]), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Baker Exegetical Commentary on the New Testament")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("CO")])]), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Ioannis Calvini Opera Quae Supersunt Omnia")]), _vm._v(" (Baum, Cunitz, Reuss)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Comm.")])]), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Commentaries of John Calvin")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("CR")])]), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Corpus Reformatorum")]), _vm._v(" (Braunschweig, 1834–)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("ETS")]), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Evangelical Theological Society")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("HTR")])]), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Harvard Theological Review")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("ICC")]), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("International Critical Commentary")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Institutes")])]), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("1559 "), _c('i', [_vm._v("Institutes of the Christian Religion")]), _vm._v(" (McNeill/Battles)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Institutes")]), _vm._v(" (1536)")]), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("1536 "), _c('i', [_vm._v("Institutes of the Christian Religion")]), _vm._v(" (Battles)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("IVPNTCS")]), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("InterVarsity Press New Testament Commentary Series")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("JBL")])]), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Journal of Biblical Literature")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("JETS")])]), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Journal of the Evangelical Theological Society")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("JSNTSup")]), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Journal for the Study of the New Testament, Supplement Series")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("NICNT")]), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("New International Commentary on the New Testament")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("NIGTC")]), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("New International Greek Testament Commentary")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("SBLDS")]), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Society of Biblical Literature Dissertation Series")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("SHR")]), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Studies in the History of Religions")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("SNTSMS")]), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Society for New Testament Studies Monograph Series")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Tracts and Treatises")])]), _c('td', {
    staticClass: "tdleft"
  }, [_c('i', [_vm._v("Tracts and Treatises of John Calvin")]), _vm._v(" (Beveridge)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("WBC")]), _c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Word Bible Commentary")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53dde613","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/abbreviations.vue
// module id = 78
// module chunks = 0